import { GridGame, type GridGameConfig } from "./GridGame";
import type { GuessRow } from "../components/wordle/keystate";

interface View {
  rows: GuessRow[];
  target: number;
  maxGuesses: number;
  solution?: string;
}

const EXPR_LENGTH = 6;
const MATH_ROWS: string[][] = [
  ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"],
  ["+", "-", "*", "/", "back"],
];
const KEY_LABELS: Record<string, string> = { "*": "×", "/": "÷" };
const pretty = (s: string) => s.replace(/\*/g, "×").replace(/\//g, "÷");

const CONFIG: GridGameConfig<View> = {
  game: "mathle",
  title: "MATHLE",
  cols: EXPR_LENGTH,
  rows: (v) => v.rows,
  errorCopy: {
    invalid_expr: "Це не схоже на вираз",
    leading_zero: "Число не починається з 0",
    bad_math: "Ділення має бути націло",
  },
  shakeCodes: ["invalid_expr", "leading_zero", "bad_math"],
  tooShort: "Замало символів",
  charOk: (k) => /^[0-9+\-*/]$/.test(k),
  mapKey: (e) => (e.key === "x" || e.key === "х" ? "*" : e.key === ":" ? "/" : null),
  pretty,
  keyboardRows: MATH_ROWS,
  keyLabels: KEY_LABELS,
  aboveGrid: (v) => (
    <div className="text-center">
      <span className="rounded-xl bg-tgsection px-4 py-1.5 text-xl font-extrabold tracking-wide">= {v.target}</span>
      <div className="mt-1.5 text-[11px] text-tghint">склади вираз із 6 символів, що дорівнює цілі</div>
    </div>
  ),
  shareTitle: "Mathle",
  lostSubtitle: (v) => `вираз був ${v.solution ? pretty(v.solution) : "?"} = ${v.target}`,
  reservedPx: 340,
  dynamicError: (code, v) => (code === "not_target" ? `Вираз ≠ ${v.target}` : null),
};

export function Mathle({ date }: { date?: string | undefined }) {
  return <GridGame config={CONFIG} date={date} />;
}
